export const adminCommonMessagesEn = {
  'admin-common.peopleSection.title': 'People',
  'admin-common.peopleSection.annotators': 'Annotators',
  'admin-common.peopleSection.supervisors': 'Supervisors',
  'admin-common.peopleSection.addAnnotator': 'Add annotator',
  'admin-common.peopleSection.addSupervisor': 'Add supervisor',
  'admin-common.peopleSection.annotatorRemovalHint':
    'New annotators can only be removed before saving project changes',
  'admin-common.peopleSection.removePerson': 'Remove {name}',
  'admin-common.peopleSection.noPeopleToAdd': 'Everyone available is already added.',
  'admin-common.peopleSection.supervisorRemovalHint': 'At least one supervisor is required.',
  'admin-common.peopleSection.lastSupervisorTooltip': 'At least one supervisor is required.',
};
